<template>
    <q-page padding>
        <q-tabs color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab default slot="title" name="privacy_policy" :label="$t('privacy_policy')" icon="fas fa-user-secret" />

            <q-tab-pane  name="privacy_policy" class="q-px-md q-pb-xl q-mt-md">
                <div class="text-center logo-institutional" v-if="$route.name === 'privacy'">
                    <img class="cursor-pointer" :src="login_logo" @click="$router.push({ name: 'login' })" />
                </div>

                <div class="row text-weight-regular q-pt-md">
                    <div class="col-12">
                        <span v-html="getPrivacy"></span>
                    </div>
                </div>

                <div class="row reverse">
                    <div class="col-xs-12 col-sm-3 text-right">
                        <q-btn flat color="secondary" :label="$t('back')" icon="fas fa-chevron-left" @click="$router.push({ name: 'login' })" />
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "login"] },

    data() {
        return {
            privacies: []
        }
    },

    computed: {
        ...mapGetters({
            login_logo: 'params/login_logo',
            id_user_language_selected: 'common/id_user_language_selected'
        }),

        getPrivacy() {
            let obj = this.privacies.find((obj) => { return obj.language === this.id_user_language_selected && obj.body !== null })
            if (obj) {
                return obj.body
            }
            else {
                let obj = this.privacies.find((obj) => { return obj.body !== '' })
                if (obj) {
                    return obj.body
                }
            }
            return ''
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get('/etraining_login/privacy/', this.getHeader)
	        .then(response => {
                this.privacies = response.data
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        getProjectName() {
            return process.env.PROJECT_NAME
        }
    },

    created() {
        this.fetchData()
    }
}
</script>

<style lang="stylus" scoped>

</style>
